export default {
  'error-code.ARE-0000': 'You are not authorized to access this content',
  'error-code.ARE-0002': 'Wrong verification code',
  'error-code.ARE-0003': 'Verification code was expired',
  'error-code.ARE-0004':
    'You have received verification codes that exceeded the allowed number of times. Please try again in 30 minutes!',
  'error-code.ARE-0008': 'Phone number is wrong format',
};
